import Paper from "@mui/material/Paper"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import { items } from "../content/items"
import { Article } from "../_/components/Article"
import { Ref } from "../_/components/Reference"

export const Shop = () => (
    <>
        <Article.Title>
            Plecak
        </Article.Title>
        <Article.Body>
            Przy sobie możesz posiadać 3 przedmioty, domyślnie są one umieszczone w plecaku. Przedmioty powinny odpowiadać wagą i rozmiarem Twojemu Ciału.
        </Article.Body>

        <Article.Title>
            Zasoby
        </Article.Title>
        <Article.Body>
            Dodatkowo poza trzema ścieśle okreslonymi przedmiotami w swoim plecaku nosisz też niezdefiniowane przedmioty nazywane zasobami. 
            Ich ilość i rzadkość określona jest <Ref>Kością Zasobów</Ref>. Zaczynasz grę z <Ref>Kością Zasobów K20</Ref>.
           Jeśli będziesz potrzebować jakiegoś przedmiotu, którego akurat nie masz zapisanego w plecaku możesz posłużyć się Zasobami. 
           Zapytaj Gapia o rzadkość przedmiotu, którego potrzebujesz i rzuć kością by zweryfikować czy akurat masz przy sobie ten przedmiot. 
           Stopień łatwości dla poszczególnych kategorii przedmiotów znajdziesz w tabeli poniżej.
           Po takiej próbie niezależnie czy była udana czy nie Kość zasobów spada o jeden aż do całkowitego wyczerpania zasobów(brak możliwości rzutu).
           Będąc w sklepie możesz dokupić zasoby ulepszając ich kość.
           Przedmiot który zmanifestował się z zasobów zostaje z graczem do końca sesji, chyba, że wymieni go z innym ze swojego plecaka.
        </Article.Body>

        <TableContainer component={Paper} sx={{ marginTop: "32px" }}>
            <Table  aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>Przedmiot</TableCell>
                        <TableCell>Cena</TableCell>
                        <TableCell>Opis</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>


                    {items.map((row) => (
                        <TableRow
                            key={row.name}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell component="th" scope="row">
                                {row.name}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {row.price}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {row.description}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    </>
)
